<template>
  <div>
    <div class="large">
      <div class="h-16 pt-3 w-item"  v-for="(item, index) in data_item" :key="`item-top-${index}`" style="border-right: 1px solid #DCDEE0;" :style="item.name === 'ログアウト' ? 'border-right: 0px' : ''">
        <div class="grid text-center self-center mx-2" @click="checkLogin(item), gotoPath(item.path)">
          <a class="text-black"><i @click="item.name === 'ログアウト' ? logout() : ''" :class="item.icon" /></a>
          <a><span class="mt-1 f-12 text-black" @click="item.name === 'ログアウト' ? logout() : ''">{{ item.name }}</span></a>
        </div>
      </div>
    </div>

    <div class="small">
      <div v-for="data_item in data_item_sm" :key="data_item">
        <div class="text-center self-center mr-4">
          <i :class="data_item.icon" />
        </div>
      </div>
    </div>
    <InstructionLogin3 :visible="showPopup" @ok="showPopup = false" @cancel="showPopup = false"/>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'select-menu',
  components: {
  },
  data() {
    return {
      showPopup: false,
      data_item: [
        // {
        //   icon: 'icon icon-bor-shopping-cart-time',
        //   name: '00ポイント',
        //   path: '/mypage/favorites'
        // },
        {
          icon: 'icon icon-bor-note-book',
          name: 'クーポン一覧'
        },
        {
          icon: 'icon icon-bor-heart-solid',
          name: 'お気に入り',
          path: '/mypage/favorites'
        },
        {
          icon: 'icon icon-bor-shopping-cart-time',
          name: '申込履歴',
          path: '/mypage/orders'
        },
        {
          icon: 'icon icon-bor-account-solid',
          name: 'マイページ',
          path: '/mypage'
        },
        {
          icon: 'icon icon-bor-logout-solid',
          name: 'ログアウト'
        }
      ],
      data_item_sm: [
        {
          icon: 'icon icon-bor-shop'
        },
        {
          icon: 'icon icon-bor-coupon'
        },
        {
          icon: 'icon icon-bor-heart'
        }
      ]
    }
  },
  computed: {
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    }
  },
  methods: {
    gotoPath(router) {
      const query = this.$route.query
      this.$router.push({path: router, query})
    },
    checkLogin(item) {
      if(item.name === 'マイページ') { 
        if (!this.$auth.loggedIn) {
          this.showPopup = true
        }
      }
    },
    async logout() {
      // CRM独自対応
      // window.dataLayer.push({
      //   event: "braze_logout",
      // });
      this.$repositories('user').logout().then(
        (response) => {
          this.$auth.user = null
          this.$auth.loggedIn = false
          this.$router.push({path: '/'})
          console.log('response ', response)
        },
        (error) => {
          this.$toastr.error(error?.message)
        }
      )
    }
  }

}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>